<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import TagView from "./TagView.svelte";

    const dispatcher = createEventDispatcher();

    export let spaceUniqueId;
    export let appUniqueId;
    export let binaryTag;
    export let isShowDelete = false;
    export let canJumpUrl = false;
    let isLoading = false;


    $: tag = (() => {
        if (binaryTag == null) {
            return null;
        }
        const tag = binaryTag.tag;
        return tag;
    })();

    $: jumpUrl = (() => {
        if (!canJumpUrl) {
            return null;
        }

        const paramMap = {};

        const tagName = tag.name;
        paramMap['binary_tag_names'] = tagName;


        const url = UrlUtil.createWebUrl(`space/${spaceUniqueId}/app/${appUniqueId}`, paramMap);

        return url;
    })();

    onMount(() => {
    });

    function onClickDelete() {
        const paramMap = {};
        paramMap['id'] = binaryTag.id;


        const url = UrlUtil.createApiUrl("binary_tag");

        isLoading = true;
        HttpRequestUtil.deleteRequest(url, paramMap, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            dispatcher('update');
        });
    }

</script>

<div class="binary-tag-view">
    <TagView tag={tag} jumpUrl={jumpUrl} isShowDelete={isShowDelete} on:delete={onClickDelete} on:click/>


</div>
<style lang="scss">
    .binary-tag-view {

    }
</style>